import { BaseControl } from '../controls/base-control.model';

export interface BaseControlOption { }
interface PropertyOption extends BaseControlOption { }
interface ValidationOption extends BaseControlOption {
  validate(ctrl: BaseControl): boolean;
  getMessage(ctrl: BaseControl): string;
}

export class ValueProperty<T> implements PropertyOption {
  type: string;
  value: T;
  label?: string

  constructor(val: T) { this.value = val; }
}

export class ValueExpression<T> {

  exp: () => T;

  constructor(e: () => T) { this.exp = e; }
}

export class ReadOnlyProperty extends ValueProperty<boolean> {
  constructor() { super(true); }
}

export class VisibleProperty extends ValueExpression<boolean> {

  constructor(exp: () => boolean) { super(exp); }

  evaluate(): boolean {
    return this.exp();
  }
}

export class ReadOnlyIf extends ValueExpression<boolean> {

  constructor(exp: () => boolean) { super(exp); }

  evaluate(): boolean {
    return this.exp();
  }
}

export class RequiredIf extends ValueExpression<boolean> {

  constructor(exp: () => boolean) { super(exp); }

  evaluate(): boolean {
    return this.exp();
  }

}

export class AddEditLinkProperty extends ValueProperty<string> {

  constructor(apiController: string) { super(apiController); }

}

export class RequiredValidator implements ValidationOption {

  message: string;

  constructor() {
    this.message = "Required Field";
  }

  validate(ctrl: BaseControl) {
    var value = Reflect.get(ctrl, "value");

    var hasValue: boolean = value !== undefined && value !== null;
    return hasValue;
  }

  getMessage() {
    return this.message;
  }

}





